import request from '@/utils/request'
/*权限*/
let AuthUserApi = {
  /*获取当前角色权限*/
  getRoleList(data, errorback) {
    return request._post('/shop/auth_app.user/getRoleList', data, errorback);
  },
  /*获取角色信息*/
  getUserInfo(data, errorback) {
    return request._post('/shop/auth_app.user/getUserInfo', data, errorback);
  },
  /*角色列表*/
  roleList(data, errorback) {
    return request._post('/shop/auth_app.role/index', data, errorback);
  },
  /*管理员列表*/
  userList(data, errorback) {
    return request._post('/shop/auth_app.user/index', data, errorback);
  },
  /*添加管理员需要的数据*/
  userAddInfo(data, errorback) {
    return request._get('/shop/auth_app.user/add', data, errorback);
  },
  /*添加管理员*/
  userAdd(data, errorback) {
    return request._post('/shop/auth_app.user/add', data, errorback);
  },
 /*修改管理员需要的数据*/
  userEditInfo(data, errorback) {
    return request._get('/shop/auth_app.user/edit', data, errorback);
  },
  /*修改管理员*/
  userEdit(data, errorback) {
    return request._post('/shop/auth_app.user/edit', data, errorback);
  },
  /*删除管理员*/
  userDelete(data, errorback) {
    return request._post('/shop/auth_app.user/delete', data, errorback);
  },
}
export default AuthUserApi;



// WEBPACK FOOTER //
// ./src/api/authuser.js